import React, { useState, useEffect, useContext, useMemo } from 'react'
import Utilities from '../Utilities/Utilities'
import Modules from '../Equipment/Modules'
import Inverters from '../Equipment/Inverters'
import LoanProducts from '../LoanProducts/LoanProducts'
import SalesTeams from '../SalesTeams/SalesTeams'
import axios from 'axios'
import Alert from 'react-s-alert'
import Title from '../Title/Title'
import moment from 'moment'
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import './Admin.css'
import Users from '../Users/Users'
import AuthGroupWrapper from '../Auth/AuthGroupWrapper'
import { withAuthenticator } from '@aws-amplify/ui-react'

// THis is the main admin page
// This has the equipment
// 


import { UserContext } from '../../UserContext'

import Amplify, { Auth } from 'aws-amplify'

const Admin = () => {

  const { activeUser, setActiveUser } = useContext(UserContext);


  const [loanProducts, setLoanProducts] = useState([])
  const [statesList, setStatesList] = useState([])
  const [stateInfo, setStateInfo] = useState([])
  const [utilities, setUtilities] = useState([])
  const [modules, setModules] = useState([])
  const [inverters, setInverters] = useState([])
  const [salesTeams, setSalesTeams] = useState([])

  const [viewUtilities, setViewUtilities] = useState(false)
  const [viewModules, setViewModules] = useState(false)
  const [viewInverters, setViewInverters] = useState(false)
  const [viewLoanProducts, setViewLoanProducts] = useState(false)
  const [viewSalesTeams, setViewSalesTeams] = useState(false)
  const [viewUsers, setViewUsers] = useState(false)

  const [addMod, setAddMod] = useState('')
  const [modMake, setModMake] = useState('')
  const [modSize, setModSize] = useState('')
  const [modModel, setModModel] = useState('')
  const [ptcRating, setPtcRating] = useState('')

  const [massEdit, setMassEdit] = useState('')
  const [massTeamEdit, setMassTeamEdit] = useState('')

  const [stateEdit, setStateEdit] = useState(false)

  const [preModId, setPreModId] = useState('')
  const [newModId, setNewModId] = useState('')
  const [preLoanId1, setPreLoanId1] = useState('')
  const [newLoanId1, setNewLoanId1] = useState('')
  const [preLoanId2, setPreLoanId2] = useState('')
  const [newLoanId2, setNewLoanId2] = useState('')

  const [preLoanId1Team, setPreLoanId1Team] = useState('')
  const [newLoanId1Team, setNewLoanId1Team] = useState('')
  const [preLoanId2Team, setPreLoanId2Team] = useState('')
  const [newLoanId2Team, setNewLoanId2Team] = useState('')

  const [addSTeam, setAddSTeam] = useState('')
  const [teamName, setTeamName] = useState('')
  const [teamLocation, setTeamLocation] = useState('')
  const [loanId1, setLoanId1] = useState('')
  const [loanId2, setLoanId2] = useState('')
  const [loanId3, setLoanId3] = useState('')
  const [loanChange, setLoanChange] = useState('')
  const [teamPpw, setTeamPpw] = useState('')
  // const [cashPpw, setCashPpw] = useState('')
  const [hasTeamPpw] = useState('0')
  const [optionChangeLoan, setOptionChangeLoan] = useState('0')
  const [specialLoanIncrease, setSpecialLoanIncrease] = useState('0')
  const [loanOption1, setLoanOption1] = useState([])
  const [loanOption2, setLoanOption2] = useState([])

  const [addLoan, setAddLoan] = useState('')
  const [loanName, setLoanName] = useState('')
  const [loanTerm, setLoanTerm] = useState('')
  const [loanInterest, setLoanInterest] = useState('')
  const [dealerFee, setDealerFee] = useState('')
  const [prePmtFactor, setPrePmtFactor] = useState('')
  const [noItcPmtFactor, setNoItcPmtFactor] = useState('')
  const [intOnlyPmtFactor, setIntOnlyPmtFactor] = useState('')
  const [itc, setItc] = useState('')
  const [specialPrice, setSpecialPrice] = useState('')
  const [isPpa, setIsPpa] = useState('0')
  const [ppaRate, setPpaRate] = useState('0')
  const [ppaEscalator, setPpaEscalator] = useState('0')

  const [addUtility, setAddUtility] = useState('')
  const [utilityName, setUtilityName] = useState('')
  const [utilityLocation, setUtilityLocation] = useState('')
  const [moduleId, setModuleId] = useState('')
  const [inverterId, setInverterId] = useState('')
  const [ppw] = useState('')
  const [cashPpw, setCashPpw] = useState('')
  const [rebate, setRebate] = useState('0')
  const [rType, setRType] = useState('')
  const [rPerWatt, setRPerWatt] = useState('')
  const [rFixed, setRFixed] = useState('')
  const [rCap, setRCap] = useState('')
  const [adder, setAdder] = useState('0')
  const [maxOff, setMaxOff] = useState('')
  const [maxSystem, setMaxSystem] = useState('')
  const [nest, setNest] = useState('0')
  const [hasPpa, setHasPpa] = useState('0')
  const [utilityPpa, setUtilityPpa] = useState('0')
  const [utilityLseId, setUtilityLseId] = useState('0')
  const [preferredUtility, setPreferredUtility] = useState('0')
  const [timeStamp, setTimeStamp] = useState('')
  const [user, setUser] = useState('')
  const [viewState, setViewState] = useState('')


  const [addInverter, setAddInverter] = useState('')
  const [invName, setInvName] = useState('')
  const [invModel, setInvModel] = useState('')
  const [invEffRating, setInvEffRating] = useState('')

  const [tierType, setTierType] = useState('')
  const [surcharge, setSurcharge] = useState('')
  const [tax] = useState(1)
  const [tier1, setTier1] = useState('')
  const [tier2, setTier2] = useState('')
  const [tier3, setTier3] = useState('')
  const [tier4, setTier4] = useState('')
  const [sTier1, setSTier1] = useState('')
  const [sTier2, setSTier2] = useState('')
  const [sTier3, setSTier3] = useState('')
  const [sTier4, setSTier4] = useState('')
  const [wTier1, setWTier1] = useState('')
  const [wTier2, setWTier2] = useState('')
  const [wTier3, setWTier3] = useState('')
  const [wTier4, setWTier4] = useState('')
  const [tierAmount, setTierAmount] = useState('')
  const [sTierAmount, setSTierAmount] = useState('')
  const [wTierAmount, setWTierAmount] = useState('')
  const [tier1Amount, setTier1Amount] = useState('')
  const [tier2Amount, setTier2Amount] = useState('')
  const [tier3Amount, setTier3Amount] = useState('')
  const [tier4Amount, setTier4Amount] = useState('')
  const [sTier1Amount, setSTier1Amount] = useState('')
  const [sTier2Amount, setSTier2Amount] = useState('')
  const [sTier3Amount, setSTier3Amount] = useState('')
  const [sTier4Amount, setSTier4Amount] = useState('')
  const [wTier1Amount, setWTier1Amount] = useState('')
  const [wTier2Amount, setWTier2Amount] = useState('')
  const [wTier3Amount, setWTier3Amount] = useState('')
  const [wTier4Amount, setWTier4Amount] = useState('')

  // const [viewBoy, setViewBoy] = useState('')

  const time = () => {
    setTimeStamp(moment().format('MM/DD/YY, h:mm a'))
  }

  // console.log(timeStamp)

  const cancel = () => {
    setTierType('')
    setSurcharge('')
    setTier1('')
    setTier2('')
    setTier3('')
    setTier4('')
    setSTier1('')
    setSTier2('')
    setSTier3('')
    setSTier4('')
    setWTier1('')
    setWTier2('')
    setWTier3('')
    setWTier4('')
    setTierAmount('')
    setSTierAmount('')
    setWTierAmount('')
    setTier1Amount('')
    setTier2Amount('')
    setTier3Amount('')
    setTier4Amount('')
    setSTier1Amount('')
    setSTier2Amount('')
    setSTier3Amount('')
    setSTier4Amount('')
    setWTier1Amount('')
    setWTier2Amount('')
    setWTier3Amount('')
    setWTier4Amount('')
  }
  let state = [
    { state: "Alabama" },
    { state: "Alaska" },
    { state: "Arizona" },
    { state: "Arkansas" },
    { state: "California" },
    { state: "Colorado" },
    { state: "Connecticut" },
    { state: "Delaware" },
    { state: "Florida" },
    { state: "Georgia" },
    { state: "Hawaii" },
    { state: "Idaho" },
    { state: "Illinois" },
    { state: "Indiana" },
    { state: "Iowa" },
    { state: "Kansas" },
    { state: "Kentucky" },
    { state: "Louisiana" },
    { state: "Maine" },
    { state: "Maryland" },
    { state: "Massachusetts" },
    { state: "Michigan" },
    { state: "Minnesota" },
    { state: "Mississippi" },
    { state: "Missouri" },
    { state: "Montana" },
    { state: "Nebraska" },
    { state: "Nevada" },
    { state: "New Hampshire" },
    { state: "New Jersey" },
    { state: "New Mexico" },
    { state: "New York" },
    { state: "North Carolina" },
    { state: "North Dakota" },
    { state: "Ohio" },
    { state: "Oklahoma" },
    { state: "Oregon" },
    { state: "Pennsylvania" },
    { state: "Rhode Island" },
    { state: "South Carolina" },
    { state: "South Dakota" },
    { state: "Tennessee" },
    { state: "Texas" },
    { state: "Utah" },
    { state: "Vermont" },
    { state: "Virginia" },
    { state: "Washington" },
    { state: "West Virginia" },
    { state: "Wisconsin" },
    { state: "Wyoming" }
  ]

  let options1 = loanOption1.filter(option => {
    return +option.loanId > 0
  }).map(item => item.loanId)

  let options2 = loanOption2.filter(option => {
    return +option.loanId > 0
  }).map(item => item.loanId)


  const addLoanProduct = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'add_loan_product', loan_name: loanName, loan_term: loanTerm, loan_interest: loanInterest, pre_pmt_factor: prePmtFactor, no_itc_pmt_factor: noItcPmtFactor, int_only_pmt_factor: intOnlyPmtFactor, itc: itc, active: 1, special_price: specialPrice, ppa: isPpa, ppa_rate: ppaRate, ppa_escalator: ppaEscalator, dealer_fee: dealerFee })
      .then((res) => {
        getLoanProducts()
        console.log(res)
        if (res.data.success) {
          Alert.success(`${loanName} ${loanTerm} yr ${loanInterest}% added to proposal and is ready to be assigned to utilities.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }

  const addSalesTeam = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'add_sales_team', team_name: teamName, loan_id1: loanId1, loan_id2: loanId2, has_team_ppw: hasTeamPpw, team_ppw: teamPpw, has_adder: adder, adder_id: 1, inv_id: inverterId, mod_id: moduleId, has_nest: nest, cash_ppw: cashPpw, team_location: teamLocation, loan_id1_2: loanId3, loan_change_size: loanChange, special_loan_increase: specialLoanIncrease, loan_options: options1.join(), loan_options_2: options2.join(), user: user, time_stamp: timeStamp, ppa: hasPpa })
      .then((res) => {
        getSalesTeams()
        // console.log(res)
        if (res.data.success) {
          Alert.success(`${teamName} added to proposal.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }
  // console.log(teamName, loanId1, loanId2, hasTeamPpw, teamPpw)

  const addModule = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'add_module', mod_make: modMake, mod_model: modModel, mod_size: modSize, mod_ptc_rating: ptcRating })
      .then((res) => {
        getModules()
        // console.log(res)
        if (res.data.success) {
          Alert.success(`${modMake} ${modModel} ${modSize} added to proposal and is ready to be assigned to utilities.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }

  const addNewInverter = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'add_inverter', inv_name: invName, inv_model: invModel, inv_eff_rating: invEffRating })
      .then((res) => {
        getInverters()
        // console.log(res)
        if (res.data.success) {
          Alert.success(`${invName} ${invModel} added to proposal and is ready to be assigned to utilities.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }

  const createUtility = () => {
    if (!user) {
      return Alert.error(`Please select a user.`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
      // } addNewUtility(); setAddUtility(!addUtility)
    } addNewUtilityTest(); setAddUtility(!addUtility)
  }


  const addNewUtilityTest = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'add_utility_test', utility_name: utilityName, ppw: ppw, utility_location: utilityLocation, has_rebate: rebate, rebate_type: rType, rebate_per_watt: rPerWatt, rebate_fixed_amount: rFixed, rebate_max: rCap, max_offset: maxOff, max_system_size: maxSystem, inv_id: 1, mod_id: 1, loan_id: 1, loan_id2: 1, has_adder: adder, adder_id: 1, has_nest: nest, cash_ppw: cashPpw, has_utility_discount: preferredUtility, user: user, time_stamp: timeStamp, tier_type: tierType, surcharge: surcharge, tax: tax, tier_1: tier1, tier_2: tier2, tier_3: tier3, tier_4: tier4, s_tier_1: sTier1, s_tier_2: sTier2, s_tier_3: sTier3, s_tier_4: sTier4, w_tier_1: wTier1, w_tier_2: wTier2, w_tier_3: wTier3, w_tier_4: wTier4, tier_amount: tierAmount, s_tier_amount: sTierAmount, w_tier_amount: wTierAmount, tier_1_amount: tier1Amount, tier_2_amount: tier2Amount, tier_3_amount: tier3Amount, tier_4_amount: tier4Amount, s_tier_1_amount: sTier1Amount, s_tier_2_amount: sTier2Amount, s_tier_3_amount: sTier3Amount, s_tier_4_amount: sTier4Amount, w_tier_1_amount: wTier1Amount, w_tier_2_amount: wTier2Amount, w_tier_3_amount: wTier3Amount, w_tier_4_amount: wTier4Amount, has_ppa: utilityPpa, lse_id: utilityLseId })
      .then((res) => {
        getUtilities()
        // console.log(res)
        if (res.data.success) {
          Alert.success(`${utilityName} added.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }


  const getLoanProducts = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_loan_products' })
      .then((res) => {
        // console.log(res.data)
        return setLoanProducts(res.data.data)
      })
  }

  const getStates = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_states' })
      .then((res) => {
        // console.log(res.data)
        return setStatesList(res.data.data)
      })
  }

  const getUtilities = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_utilities' }).then(
      (res) => {
        // console.log(res.data)
        return setUtilities(res.data.data)
      }
    )
  }



  const getModules = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_modules' }).then(
      (res) => {
        // console.log(res.data)
        return setModules(res.data.data)
      }
    )
  }

  const getInverters = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_inverters' }).then(
      (res) => {
        // console.log(res.data)
        return setInverters(res.data.data)
      }
    )
  }

  const getSalesTeams = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_sales_teams' }).then(
      (res) => {
        // console.log(res.data)
        return setSalesTeams(res.data.temp)
      }
    )
  }


  const updateModules = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_modules', mod_id1: newModId, mod_id2: preModId, user: user, time_stamp: timeStamp })
      .then((res) => {
        getUtilities()
        // console.log(res)
        if (res.data.success) {
          Alert.success(`Utilities have been updated.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }

  const updateLoan1 = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_loan_1', loan_id_1: newLoanId1, loan_id_2: preLoanId1, user: user, time_stamp: timeStamp })
      .then((res) => {
        getUtilities()
        console.log(res)
        if (res.data.success) {
          Alert.success(`Utilities have been updated.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }

  const updateLoan2 = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_loan_2', loan_id2_1: newLoanId2, loan_id2_2: preLoanId2, user: user, time_stamp: timeStamp })
      .then((res) => {
        getUtilities()
        console.log(res)
        if (res.data.success) {
          Alert.success(`Utilities have been updated.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }

  const updateLoan1Team = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_loan_1_team', loan_id_1: newLoanId1Team, loan_id_2: preLoanId1Team })
      .then((res) => {
        getSalesTeams()
        // console.log(res)
        if (res.data.success) {
          Alert.success(`Sales Teams have been updated.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }

  // console.log(newLoanId1Team, preLoanId1Team)

  const updateLoan2Team = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_loan_2_team', loan_id2_1: newLoanId2Team, loan_id2_2: preLoanId2Team })
      .then((res) => {
        getSalesTeams()
        // console.log(res)
        if (res.data.success) {
          Alert.success(`Sales Teams have been updated.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }

  const updateState = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_state', state_id: stateInfo.stateId, state_name: stateInfo.stateName, state_tax: stateInfo.stateTax, tax_type: stateInfo.taxType, tax_per_watt: stateInfo.taxPerWatt, tax_fixed_amount: stateInfo.taxFixed, tax_max: stateInfo.taxMax, utility_escalator: stateInfo.utilityIncrease })
      .then((res) => {
        getStates()
        setStateEdit(!stateEdit)
        // console.log(res)
        if (res.data.success) {
          Alert.success(`${stateInfo.stateName} has been updated.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }

  const massModuleUpdate = () => {
    if (!user) {
      return Alert.error(`Please select a user.`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
      // } addNewUtility(); setAddUtility(!addUtility)
    } updateModules();
  }

  const massLoan1Update = () => {
    if (!user) {
      return Alert.error(`Please select a user.`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
      // } addNewUtility(); setAddUtility(!addUtility)
    } updateLoan1();
  }

  const massLoan2Update = () => {
    if (!user) {
      return Alert.error(`Please select a user.`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
      // } addNewUtility(); setAddUtility(!addUtility)
    } updateLoan2();
  }

  useEffect(() => {
    getLoanProducts()
    getStates()
    getUtilities()
    getModules()
    getInverters()
    getSalesTeams()
  }, [])

  const viewU = () => {
    setViewUtilities(!viewUtilities)
    setViewInverters(false)
    setViewModules(false)
    setViewLoanProducts(false)
    setViewSalesTeams(false)
    setViewUsers(false)
  }

  const viewM = () => {
    setViewModules(!viewModules)
    setViewUtilities(false)
    setViewInverters(false)
    setViewLoanProducts(false)
    setViewSalesTeams(false)
    setViewUsers(false)
  }

  const viewI = () => {
    setViewInverters(!viewInverters)
    setViewModules(false)
    setViewUtilities(false)
    setViewLoanProducts(false)
    setViewSalesTeams(false)
    setViewUsers(false)
  }

  const viewL = () => {
    setViewLoanProducts(!viewLoanProducts)
    setViewInverters(false)
    setViewModules(false)
    setViewUtilities(false)
    setViewSalesTeams(false)
    setViewUsers(false)
  }

  const viewS = () => {
    setViewSalesTeams(!viewSalesTeams)
    setViewLoanProducts(false)
    setViewInverters(false)
    setViewModules(false)
    setViewUtilities(false)
    setViewUsers(false)
  }
  const viewUse = () => {
    setViewUsers(!viewUsers)
    setViewSalesTeams(false)
    setViewLoanProducts(false)
    setViewInverters(false)
    setViewModules(false)
    setViewUtilities(false)
  }


  let mappedLoans = loanProducts.map((loans, i) => {
    // console.log(loans.loanTerm)
    return <option key={i} value={loans.loanId}> {`${loans.loanName} ${loans.loanTerm} year ${loans.loanInterest}%`}</option>
  })

  let mappedModules = modules.map((mod, i) => {
    // console.log(loans.loanTerm)
    return <option key={i} value={mod.modId}> {`${mod.make} ${mod.model} ${mod.size}`}</option>
  })

  let mappedInverters = inverters.map((inv, i) => {
    // console.log(loans.loanTerm)
    return <option key={i} value={inv.invId}> {`${inv.make} ${inv.model}`}</option>
  })
  // console.log(preLoanId1, preLoanId2, newLoanId1Team, newLoanId2)

  const { uniqueStates, stateArray } = useMemo(() => {
    const stateSet = new Set();
    const filteredUtilities = utilities.filter(utility => {
      stateSet.add(utility.utilityLocation);
      return utility.utilityLocation === viewState;
    });

    return {
      uniqueStates: Array.from(stateSet), // Convert Set to Array
      stateArray: filteredUtilities
    };
  }, [utilities, viewState]);

  // Find state info based on viewState
  useEffect(() => {
    const matchedState = statesList.find(state => state.stateName === viewState);
    if (matchedState) {
      setStateInfo(matchedState);
    }
  }, [viewState, statesList]);

  // Render the unique states as options
  const mappedStates = uniqueStates.map((state, i) => (
    <option key={i} value={state}>{state}</option>
  ));

  const signOut = async () => {
    try {
      await Auth.signOut();
      await setActiveUser(null)
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }


  useEffect(() => {
    setUser(`${activeUser.attributes.given_name} ${activeUser.attributes.family_name}`)
  }, [])

  const listOfStates = require('us-state-converter')

  const fiftyStates = listOfStates.only50()

  let mappedState = fiftyStates.map((state, i) => {
    return (
      <option key={i} value={state.name}>{state.name}</option>
    )
  })


  return (
    <AuthGroupWrapper requiredGroups={['Admin', 'Super-Admin']} >
      <div className="body2">
        <Title title={`Admin Portal`} />
        <div className='itemsWrapper'>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', width: '100%', alignItems: 'center' }}>
            <div style={{ width: '20%', alignItems: 'baseline' }} >
              <h1 style={{ fontSize: '3em' }}>proposalist.</h1>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '20%', alignItems: 'flex-end' }}>
              <span>{activeUser.attributes.given_name} {activeUser.attributes.family_name}</span>
              <span>{activeUser.username}</span>
              <button onClick={() => signOut()}>Sign Out</button>
            </div>
          </div>
          <h1 style={{ fontSize: '3em' }}>admin.</h1>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ marginBottom: '1rem', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', width: '400px' }}>
              <button className={viewUtilities ? 'clickedButton button' : 'button'} onClick={() => viewU()} >Utilities</button>
              <button className={viewModules ? 'clickedButton button' : 'button'} onClick={() => viewM()}>Modules</button>
              <button className={viewInverters ? 'clickedButton button' : 'button'} onClick={() => viewI()}>Inverters</button>
              <button className={viewLoanProducts ? 'clickedButton button' : 'button'} onClick={() => viewL()}>Financing</button>
              <button className={viewSalesTeams ? 'clickedButton button' : 'button'} onClick={() => viewS()}>Sales Teams</button>
              <button className={viewUsers ? 'clickedButton button' : 'button'} onClick={() => viewUse()}>Users</button>
            </div>
            <>
              {viewUtilities ? (
                <>
                  {addUtility ? (
                    <>
                      <div>
                        <span>Utility</span>
                      </div>
                      <div className='addItem'>
                        <div style={{ alignItems: 'flex-end' }} className='addItem1'>
                          <span>Utility Name </span>
                          <span>Utility Location </span>
                          <span>Max System Size (optional):  </span>
                          <span>Max Usage Offset (optional):  </span>
                        </div>
                        <div className='addItem1'>
                          <input className='input' placeholder='name' onChange={e => setUtilityName(e.target.value)} ></input>
                          <select className='input' onChange={e => setUtilityLocation(e.target.value)}>
                            <option style={{ display: 'none' }} >
                              Select State
                            </option>
                            {mappedState}
                          </select>
                          <input className='input' placeholder='max size in watts' onChange={e => setMaxSystem(e.target.value)} ></input>
                          <input className='input' placeholder='max offset' onChange={e => setMaxOff(e.target.value)} ></input>
                        </div>
                      </div>
                      <form >
                        <span>$.40/w Preferred Utility Discount: </span>
                        <input className='input' type="radio" name='preferredUtility' onChange={e => setPreferredUtility('1')} checked={preferredUtility === '1' ? 'checked' : ''} />
                        <span>Yes</span>
                        <input className='input' type="radio" name='preferredUtility' onChange={e => setPreferredUtility('0')} checked={preferredUtility === '0' ? 'checked' : ''} />
                        <span>No</span>
                      </form>
                      <form >
                        <span>Rebate: </span>
                        <input className='input' type="radio" name='rebate' onChange={e => setRebate('1')} checked={rebate === '1' ? 'checked' : ''} />
                        <span>Yes</span>
                        <input className='input' type="radio" name='rebate' onChange={e => setRebate('0')} checked={rebate === '0' ? 'checked' : ''} />
                        <span>No</span>
                      </form>
                      {rebate === '1' ? (
                        <>
                          <div>
                            <select onChange={e => setRType(e.target.value)} className='input'>
                              <option style={{ display: 'none' }}>Rebate Type </option>
                              <option value='Per Watt D/C'>Per Watt D/C</option>
                              <option value='Per Watt A/C'>Per Watt A/C</option>
                              <option value='Fixed'>Fixed</option>
                            </select>
                          </div>
                          <div>
                            <span>Rebate Amount </span>
                            <input className='input' onChange={e => (rType === 'Fixed' ? setRFixed(e.target.value) : rType === 'Per Watt D/C' || rType === 'Per Watt A/C' ? setRPerWatt(e.target.value) : (''))}
                              placeholder={rType === 'Fixed' ? ('fixed') : rType === 'Per Watt D/C' ? ('Per Watt D/C') : rType === 'Per Watt A/C' ? ('Per Watt A/C') : ('')} ></input>
                          </div>
                          <div>
                            <span>Rebate Cap </span>
                            <input className='input' onChange={e => setRCap(e.target.value)} placeholder='rebate cap' ></input>
                          </div>
                        </>
                      ) : (
                        <>
                        </>
                      )}
                      <form >
                        <span>Has PPA: </span>
                        <input className='input' type="radio" name='utilityPpa' onChange={e => setUtilityPpa('1')} checked={utilityPpa === '1' ? 'checked' : ''} />
                        <span>Yes</span>
                        <input className='input' type="radio" name='utilityPpa' onChange={e => setUtilityPpa('0')} checked={utilityPpa === '0' ? 'checked' : ''} />
                        <span>No</span>
                      </form>
                      <div>
                        <span>Rate Information:</span>
                      </div>
                      <div className='addItem'>
                        <div style={{ alignItems: 'flex-end' }} className='addItem1'>
                          <span>Surcharge:</span>
                          <span>Tier Schedule:</span>
                        </div>
                        <div className='addItem1'>
                          <input className='input' onChange={e => setSurcharge(+e.target.value)} placeholder='surcharge' ></input>
                          <select onChange={e => setTierType(e.target.value)} className='input'>
                            <option style={{ display: 'none' }}>Tier Schedule</option>
                            <option value='Annual'>Annual</option>
                            <option value='Split'>Winter/Summer</option>
                          </select>
                        </div>
                      </div>
                      <div className='addItem'>
                        {tierType === 'Split' ? (
                          <>
                            <div style={{ alignItems: 'flex-end' }} className='addItem1'>
                              <span>Amount of Summer Tiers:</span>
                              {sTierAmount === 4 ? (
                                <>
                                  <span>Tier 1 $ per kWh:</span>
                                  <span>Tier 1 kWh Amount:</span>
                                  <span>Tier 2 $ per kWh:</span>
                                  <span>Tier 2 kWh Amount:</span>
                                  <span>Tier 3 $ per kWh:</span>
                                  <span>Tier 3 kWh Amount:</span>
                                  <span>Tier 4 $ per kWh:</span>
                                  <span>Tier 4 kWh Amount:</span>
                                </>
                              ) : sTierAmount === 3 ? (
                                <>
                                  <span>Tier 1 $ per kWh:</span>
                                  <span>Tier 1 kWh Amount:</span>
                                  <span>Tier 2 $ per kWh:</span>
                                  <span>Tier 2 kWh Amount:</span>
                                  <span>Tier 3 $ per kWh:</span>
                                  <span>Tier 3 kWh Amount:</span>
                                </>
                              ) : sTierAmount === 2 ? (
                                <>
                                  <span>Tier 1 $ per kWh:</span>
                                  <span>Tier 1 kWh Amount:</span>
                                  <span>Tier 2 $ per kWh:</span>
                                  <span>Tier 2 kWh Amount:</span>
                                </>
                              ) : sTierAmount === 1 ? (
                                <>
                                  <span>Tier 1 $ per kWh for all kWh:</span>
                                </>
                              ) : (
                                <>
                                </>
                              )}
                              <span>Amount of Winter Tiers:</span>
                              {wTierAmount === 4 ? (
                                <>
                                  <span>Tier 1 $ per kWh:</span>
                                  <span>Tier 1 kWh Amount:</span>
                                  <span>Tier 2 $ per kWh:</span>
                                  <span>Tier 2 kWh Amount:</span>
                                  <span>Tier 3 $ per kWh:</span>
                                  <span>Tier 3 kWh Amount:</span>
                                  <span>Tier 4 $ per kWh:</span>
                                  <span>Tier 4 kWh Amount:</span>
                                </>
                              ) : wTierAmount === 3 ? (
                                <>
                                  <span>Tier 1 $ per kWh:</span>
                                  <span>Tier 1 kWh Amount:</span>
                                  <span>Tier 2 $ per kWh:</span>
                                  <span>Tier 2 kWh Amount:</span>
                                  <span>Tier 3 $ per kWh:</span>
                                  <span>Tier 3 kWh Amount:</span>
                                </>
                              ) : wTierAmount === 2 ? (
                                <>
                                  <span>Tier 1 $ per kWh:</span>
                                  <span>Tier 1 kWh Amount:</span>
                                  <span>Tier 2 $ per kWh:</span>
                                  <span>Tier 2 kWh Amount:</span>
                                </>
                              ) : wTierAmount === 1 ? (
                                <>
                                  <span>Tier 1 $ per kWh for all kWh:</span>
                                </>
                              ) : (
                                <>
                                </>
                              )}
                            </div>
                            <div className='addItem1'>
                              <select onChange={e => setSTierAmount(+e.target.value)} className='input'>
                                <option style={{ display: 'none' }}>Summer Tiers</option>
                                <option value='1'>1</option>
                                <option value='2'>2</option>
                                <option value='3'>3</option>
                                <option value='4'>4</option>
                              </select>
                              {sTierAmount === 4 ? (
                                <>
                                  <input className='input' onChange={e => setSTier1(+e.target.value)} placeholder='1 per kWh' ></input>
                                  <input className='input' onChange={e => setSTier1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                                  <input className='input' onChange={e => setSTier2(+e.target.value)} placeholder='2 per kWh' ></input>
                                  <input className='input' onChange={e => setSTier2Amount(+e.target.value)} placeholder='2 kWh amount' ></input>
                                  <input className='input' onChange={e => setSTier3(+e.target.value)} placeholder='3 per kWh' ></input>
                                  <input className='input' onChange={e => setSTier3Amount(+e.target.value)} placeholder='3 kWh amount' ></input>
                                  <input className='input' onChange={e => setSTier4(+e.target.value)} placeholder='4 per kWh' ></input>
                                  <span>{sTier3Amount ? `${sTier3Amount + 1}+` : '-'}</span>
                                </>
                              ) : sTierAmount === 3 ? (
                                <>
                                  <input className='input' onChange={e => setSTier1(+e.target.value)} placeholder='1 per kWh' ></input>
                                  <input className='input' onChange={e => setSTier1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                                  <input className='input' onChange={e => setSTier2(+e.target.value)} placeholder='2 per kWh' ></input>
                                  <input className='input' onChange={e => setSTier2Amount(+e.target.value)} placeholder='2 kWh amount' ></input>
                                  <input className='input' onChange={e => setSTier3(+e.target.value)} placeholder='3 per kWh' ></input>
                                  <span>{sTier2Amount ? `${sTier2Amount + 1}+` : '-'}</span>
                                </>
                              ) : sTierAmount === 2 ? (
                                <>
                                  <input className='input' onChange={e => setSTier1(+e.target.value)} placeholder='1 per kWh' ></input>
                                  <input className='input' onChange={e => setSTier1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                                  <input className='input' onChange={e => setSTier2(+e.target.value)} placeholder='2 per kWh' ></input>
                                  <span>{sTier1Amount ? `${sTier1Amount + 1}+` : '-'}</span>
                                </>
                              ) : sTierAmount === 1 ? (
                                <>
                                  <input className='input' onChange={e => setSTier1(+e.target.value)} placeholder='1 per kWh' ></input>
                                </>
                              ) : (
                                <>
                                </>
                              )}
                              <select onChange={e => setWTierAmount(+e.target.value)} className='input'>
                                <option style={{ display: 'none' }}>Winter Tiers</option>
                                <option value='1'>1</option>
                                <option value='2'>2</option>
                                <option value='3'>3</option>
                                <option value='4'>4</option>
                              </select>
                              {wTierAmount === 4 ? (
                                <>
                                  <input className='input' onChange={e => setWTier1(+e.target.value)} placeholder='1 per kWh' ></input>
                                  <input className='input' onChange={e => setWTier1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                                  <input className='input' onChange={e => setWTier2(+e.target.value)} placeholder='2 per kWh' ></input>
                                  <input className='input' onChange={e => setWTier2Amount(+e.target.value)} placeholder='2 kWh amount' ></input>
                                  <input className='input' onChange={e => setWTier3(+e.target.value)} placeholder='3 per kWh' ></input>
                                  <input className='input' onChange={e => setWTier3Amount(+e.target.value)} placeholder='3 kWh amount' ></input>
                                  <input className='input' onChange={e => setWTier4(+e.target.value)} placeholder='4 per kWh' ></input>
                                  <span>{wTier3Amount ? `${wTier3Amount + 1}+` : '-'}</span>
                                </>
                              ) : wTierAmount === 3 ? (
                                <>
                                  <input className='input' onChange={e => setWTier1(+e.target.value)} placeholder='1 per kWh' ></input>
                                  <input className='input' onChange={e => setWTier1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                                  <input className='input' onChange={e => setWTier2(+e.target.value)} placeholder='2 per kWh' ></input>
                                  <input className='input' onChange={e => setWTier2Amount(+e.target.value)} placeholder='2 kWh amount' ></input>
                                  <input className='input' onChange={e => setWTier3(+e.target.value)} placeholder='3 per kWh' ></input>
                                  <span>{wTier2Amount ? `${wTier2Amount + 1}+` : '-'}</span>
                                </>
                              ) : wTierAmount === 2 ? (
                                <>
                                  <input className='input' onChange={e => setWTier1(+e.target.value)} placeholder='1 per kWh' ></input>
                                  <input className='input' onChange={e => setWTier1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                                  <input className='input' onChange={e => setWTier2(+e.target.value)} placeholder='2 per kWh' ></input>
                                  <span>{wTier1Amount ? `${wTier1Amount + 1}+` : '-'}</span>
                                </>
                              ) : wTierAmount === 1 ? (
                                <>
                                  <input className='input' onChange={e => setWTier1(+e.target.value)} placeholder='1 per kWh' ></input>
                                </>
                              ) : (
                                <>
                                </>
                              )}
                            </div>
                          </>
                        ) : tierType === 'Annual' ? (
                          <>
                            <div style={{ alignItems: 'flex-end' }} className='addItem1'>
                              <span>Amount of Tiers:</span>
                              {tierAmount === 4 ? (
                                <>
                                  <span>Tier 1 $ per kWh:</span>
                                  <span>Tier 1 kWh Amount:</span>
                                  <span>Tier 2 $ per kWh:</span>
                                  <span>Tier 2 kWh Amount:</span>
                                  <span>Tier 3 $ per kWh:</span>
                                  <span>Tier 3 kWh Amount:</span>
                                  <span>Tier 4 $ per kWh:</span>
                                  <span>Tier 4 kWh Amount:</span>
                                </>
                              ) : tierAmount === 3 ? (
                                <>
                                  <span>Tier 1 $ per kWh:</span>
                                  <span>Tier 1 kWh Amount:</span>
                                  <span>Tier 2 $ per kWh:</span>
                                  <span>Tier 2 kWh Amount:</span>
                                  <span>Tier 3 $ per kWh:</span>
                                  <span>Tier 3 kWh Amount:</span>
                                </>
                              ) : tierAmount === 2 ? (
                                <>
                                  <span>Tier 1 $ per kWh:</span>
                                  <span>Tier 1 kWh Amount:</span>
                                  <span>Tier 2 $ per kWh:</span>
                                  <span>Tier 2 kWh Amount:</span>
                                </>
                              ) : tierAmount === 1 ? (
                                <>
                                  <span>Tier 1 $ per kWh for all kWh:</span>
                                </>
                              ) : (
                                <>
                                </>
                              )}
                            </div>
                            <div className='addItem1'>
                              <select onChange={e => setTierAmount(+e.target.value)} className='input'>
                                <option style={{ display: 'none' }}>Tiers</option>
                                <option value='1'>1</option>
                                <option value='2'>2</option>
                                <option value='3'>3</option>
                                <option value='4'>4</option>
                              </select>
                              {tierAmount === 4 ? (
                                <>
                                  <input className='input' onChange={e => setTier1(+e.target.value)} placeholder='1 per kWh' ></input>
                                  <input className='input' onChange={e => setTier1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                                  <input className='input' onChange={e => setTier2(+e.target.value)} placeholder='2 per kWh' ></input>
                                  <input className='input' onChange={e => setTier2Amount(+e.target.value)} placeholder='2 kWh amount' ></input>
                                  <input className='input' onChange={e => setTier3(+e.target.value)} placeholder='3 per kWh' ></input>
                                  <input className='input' onChange={e => setTier3Amount(+e.target.value)} placeholder='3 kWh amount' ></input>
                                  <input className='input' onChange={e => setTier4(+e.target.value)} placeholder='4 per kWh' ></input>
                                  <span>{tier3Amount ? `${tier3Amount + 1}+` : '-'}</span>
                                </>
                              ) : tierAmount === 3 ? (
                                <>
                                  <input className='input' onChange={e => setTier1(+e.target.value)} placeholder='1 per kWh' ></input>
                                  <input className='input' onChange={e => setTier1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                                  <input className='input' onChange={e => setTier2(+e.target.value)} placeholder='2 per kWh' ></input>
                                  <input className='input' onChange={e => setTier2Amount(+e.target.value)} placeholder='2 kWh amount' ></input>
                                  <input className='input' onChange={e => setTier3(+e.target.value)} placeholder='3 per kWh' ></input>
                                  <span>{tier2Amount ? `${tier2Amount + 1}+` : '-'}</span>
                                </>
                              ) : tierAmount === 2 ? (
                                <>
                                  <input className='input' onChange={e => setTier1(+e.target.value)} placeholder='1 per kWh' ></input>
                                  <input className='input' onChange={e => setTier1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                                  <input className='input' onChange={e => setTier2(+e.target.value)} placeholder='2 per kWh' ></input>
                                  <span>{tier1Amount ? `${tier1Amount + 1}+` : '-'}</span>
                                </>
                              ) : tierAmount === 1 ? (
                                <>
                                  <input className='input' onChange={e => setTier1(+e.target.value)} placeholder='1 per kWh' ></input>
                                </>
                              ) : (
                                <>
                                </>
                              )}

                            </div>
                          </>
                        ) : (
                          <>
                          </>
                        )}
                      </div>
                      <div>
                        <button onClick={() => createUtility()}>Create New Utility</button>
                      </div>
                      <div>
                        <button onClick={() => { setAddUtility(!addUtility); cancel() }}>Cancel</button>
                      </div>
                    </>
                  ) : (
                    <>
                      <AuthGroupWrapper requiredGroups={['Super-Admin']} >
                        <div>
                          <button onClick={() => { setAddUtility(!addUtility); time() }}>Add New Utility</button>
                          <button onClick={() => { setMassEdit(!massEdit); time() }}>Mass Update</button>
                        </div>
                      </AuthGroupWrapper>
                      <div>
                      </div>
                      <select onChange={e => setViewState(e.target.value)} className='input'>
                        <option style={{ display: 'none' }}>State</option>
                        {mappedStates}
                      </select>
                    </>
                  )}
                  {massEdit ? (
                    <>
                      <div>
                        <span>Modules</span>
                      </div>
                      <div>
                        <span>Current Module </span>
                        <select onChange={e => setPreModId(e.target.value)} className='input'>
                          <option style={{ display: 'none' }} >
                            Current Module
                          </option>
                          {mappedModules}
                        </select>
                        <span>New Module </span>
                        <select onChange={e => setNewModId(e.target.value)} className='input'>
                          <option style={{ display: 'none' }} >
                            New Module
                          </option>
                          {mappedModules}
                        </select>
                      </div>
                      <div>
                        <button onClick={() => massModuleUpdate()}>Change All Utilities with Current Module to New Module</button>
                      </div>
                      <div>
                        <span>Financial Products</span>
                      </div>
                      <div>
                        <span>Current Option 1 </span>
                        <select onChange={e => setPreLoanId1(e.target.value)} className='input'>
                          <option style={{ display: 'none' }} >
                            Current Option 1
                          </option>
                          {mappedLoans}
                        </select>
                        <span>New Option 1 </span>
                        <select onChange={e => setNewLoanId1(e.target.value)} className='input'>
                          <option style={{ display: 'none' }} >
                            New Option 1
                          </option>
                          {mappedLoans}
                        </select>
                      </div>
                      <div>
                        <button onClick={() => massLoan1Update()}>Update Utilities with Current Option 1 to New Option 1</button>
                      </div>
                      <div>
                        <span>Current Option 2 </span>
                        <select onChange={e => setPreLoanId2(e.target.value)} className='input'>
                          <option style={{ display: 'none' }} >
                            Current Option 2
                          </option>
                          {mappedLoans}
                        </select>
                        <span>New Option 2 </span>
                        <select onChange={e => setNewLoanId2(e.target.value)} className='input'>
                          <option style={{ display: 'none' }} >
                            New Option 2
                          </option>
                          {mappedLoans}
                        </select>
                      </div>
                      <div>
                        <button onClick={() => massLoan2Update()}>Update Utilities with Current Option 2 to New Option 2</button>
                      </div>
                      <div>
                        <button onClick={() => setMassEdit(!massEdit)}>Cancel</button>
                      </div>
                    </>
                  ) : (
                    <>
                    </>
                  )}
                  {viewState ? (
                    <>
                      <h1>{stateInfo.stateName}</h1>
                      {stateEdit ? (
                        <>
                          <div>
                            <span>Annual Utility Increase %: </span>
                            <input className='input' onChange={e => setStateInfo({ ...stateInfo, utilityIncrease: e.target.value })} value={stateInfo.utilityIncrease} placeholder='annual utility increase %' ></input>
                          </div>
                          <form >
                            <span>State Tax: </span>
                            <input className='input' type="radio" name='stateTax' onChange={e => setStateInfo({ ...stateInfo, stateTax: 1 })} checked={+stateInfo.stateTax === 1 ? 'checked' : ''} />
                            <span>Yes</span>
                            <input className='input' type="radio" name='stateTax' onChange={e => setStateInfo({ ...stateInfo, stateTax: 0 })} checked={+stateInfo.stateTax === 0 ? 'checked' : ''} />
                            <span>No</span>
                          </form>
                          {+stateInfo.stateTax === 1 ? (
                            <>
                              <div>
                                <select onChange={e => setStateInfo({ ...stateInfo, taxType: e.target.value })} className='input'>
                                  <option style={{ display: 'none' }}>Tax Type </option>
                                  <option value='Per Watt'>Per Watt</option>
                                  <option value='Percentage'>Percentage</option>
                                  <option value='Fixed'>Fixed</option>
                                </select>
                              </div>
                              <div>
                                <span>Tax Amount </span>
                                <input className='input' onChange={e => (stateInfo.taxType === 'Fixed' ? setStateInfo({ ...stateInfo, taxFixed: e.target.value }) : stateInfo.taxType === 'Per Watt' ? setStateInfo({ ...stateInfo, taxPerWatt: e.target.value }) : stateInfo.taxType === 'Percentage' ? setStateInfo({ ...stateInfo, taxPerWatt: e.target.value / 100 }) : (''))}
                                  placeholder={stateInfo.taxType === 'Fixed' ? ('fixed') : stateInfo.taxType === 'Per Watt' ? ('Per Watt') : stateInfo.taxType === 'Percentage' ? ('Percentage') : ('')} ></input>
                              </div>
                              <div>
                                <span>State Tax Cap </span>
                                <input className='input' onChange={e => setStateInfo({ ...stateInfo, taxMax: e.target.value })} value={stateInfo.taxMax} placeholder='state tax cap' ></input>
                              </div>
                            </>
                          ) : (
                            <>
                            </>
                          )}
                          <button onClick={() => updateState()}>Confirm</button>
                          <button onClick={() => setStateEdit(!stateEdit)}>Cancel</button>
                        </>
                      ) : (
                        <>
                          <div>State Tax: {stateInfo.stateTax < 1 ? 'No' : 'Yes'}</div>
                          <div>Annual Utility Increase: {stateInfo.utilityIncrease}%</div>
                          {stateInfo.stateTax > 0 ? (
                            <>
                              {stateInfo.taxType === 'Percentage' ? <div>Tax Type: {stateInfo.taxType} - {(+stateInfo.taxPerWatt * 100).toLocaleString(undefined)}% of financing amount {stateInfo.taxMax > 0 ? `capped at $${stateInfo.taxMax}` : ''}</div> : stateInfo.taxType === 'Fixed' ? <div>Tax Type: {stateInfo.taxType} - ${stateInfo.taxFixed}</div> : stateInfo.taxType === 'Per Watt' ? <div>Tax Type: {stateInfo.taxType} - ${(+stateInfo.taxPerWatt).toFixed(2)}/watt {stateInfo.taxMax > 0 ? `capped at $${stateInfo.taxMax}` : ''}</div> : ''}
                            </>
                          ) : (
                            <>
                            </>
                          )}
                          <button onClick={() => setStateEdit(!stateEdit)}>Edit {stateInfo.stateName}</button>
                        </>
                      )}
                      {stateArray.map(utility => {
                        return <Utilities key={utility.utility_id} utility={utility} mappedModules={mappedModules} mappedLoans={mappedLoans} mappedInverters={mappedInverters} getUtilities={getUtilities} />
                      })}
                    </>
                  ) : (
                    <>
                    </>
                  )}
                  <div className='filler'></div>
                </>
              ) : (
                <>
                </>
              )}
            </>
            {viewModules ? (
              <>
                {addMod ? (
                  <>
                    <div>
                      <div>
                        <span>Module</span>
                      </div>
                      <a href='http://www.solardesigntool.com/compare-solar-panels-modules.html' target='_blank' rel='noopener noreferrer'><button>Module Cheat Sheets</button></a>
                    </div>
                    <div className='addItem' >
                      <div style={{ alignItems: 'flex-end' }} className='addItem1'>
                        <span>Make: </span>
                        <span>Model: </span>
                        <span>Size (watts): </span>
                        <span>PTC Rating: </span>
                      </div>
                      <div className='addItem1'>
                        <input className='input' placeholder="make" onChange={e => setModMake(e.target.value)} ></input>
                        <input className='input' placeholder="model" onChange={e => setModModel(e.target.value)} ></input>
                        <input className='input' placeholder="size" type='number' onChange={e => setModSize(e.target.value)} ></input>
                        <input className='input' placeholder="ptc rating" type='number' onChange={e => setPtcRating(e.target.value)} ></input>
                      </div>
                    </div>
                    <div>
                      <button onClick={() => addModule()}>Create New Module</button>
                    </div>
                    <button onClick={() => setAddMod(!addMod)}>Close</button>
                  </>
                ) : (
                  <>
                    <AuthGroupWrapper requiredGroups={['Super-Admin']} >
                      <button onClick={() => setAddMod(!addMod)}>Add New Module</button>
                    </AuthGroupWrapper>
                  </>
                )}
                {modules.map(module => {
                  return <Modules key={module.modId} module={module} viewModules={viewModules} />
                })}
                <div className='filler'></div>

              </>
            ) : (
              <>
              </>
            )}
            {viewInverters ? (
              <>
                {addInverter ? (
                  <>
                    <div>
                      <span>Inverter</span>
                    </div>
                    <a href='http://www.solardesigntool.com/compare-inverters.html' target='_blank' rel='noopener noreferrer'><button>Inverter Cheat Sheets</button></a>
                    <div className='addItem'>
                      <div style={{ alignItems: 'flex-end' }} className='addItem1'>
                        <span>Make: </span>
                        <span>Model: </span>
                        <span>Efficiency Rating: </span>
                      </div>
                      <div className='addItem1' >
                        <input className='input' placeholder='make' onChange={e => setInvName(e.target.value)}></input>
                        <input className='input' placeholder='model' onChange={e => setInvModel(e.target.value)}></input>
                        <input className='input' placeholder='Efficiency Rating' type='number' onChange={e => setInvEffRating(e.target.value / 100)}></input>
                      </div>
                    </div>
                    <div>
                      <button onClick={() => addNewInverter()}>Create New Inverter</button>
                    </div>
                    <button onClick={() => setAddInverter(!addInverter)}>Cancel</button>
                  </>
                ) : (
                  <>
                    <AuthGroupWrapper requiredGroups={['Super-Admin']} >
                      <button onClick={() => setAddInverter(!addInverter)}>Add New Inverter</button>
                    </AuthGroupWrapper>
                  </>
                )}
                {inverters.map(inverter => {
                  return <Inverters key={inverter.invId} inverter={inverter} />
                })}
                <div className='filler'></div>
              </>
            ) : (
              <>
              </>
            )}
            {viewSalesTeams ? (
              <>
                {addSTeam ? (
                  <>
                    <div>
                      <span>Sales Team</span>
                    </div>
                    <div className='addItem'>
                      <div style={{ alignItems: 'flex-end' }} className='addItem1'>
                        {/* <span>Team Name </span>
                      <span>Location </span>
                      <span>Module </span>
                      <span>Inverter </span>
                      <span>Loan Option 1 </span>
                      <span>Loan Option 2 </span>
                      <span>Full Commission PPW:</span>
                      <span>Cash PPW:</span> */}

                        <TextField className='input' style={{ width: 225 }} label="Team Name" variant="filled" size="small" margin="dense" onChange={e => setTeamName(e.target.value)}></TextField>
                        {/* <input className='input' placeholder='team name' onChange={e => setTeamName(e.target.value)}></input> */}
                        <Autocomplete disableClearable id="tags-outlined-state" options={state} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => `${option.state}`} value={state.state} onChange={(event, value) => setTeamLocation(value.state)} style={{ width: 225 }}
                          renderInput={(params) => (
                            <TextField className='input'  {...params} variant="filled" size="small" label="State" margin="dense" width="80%"
                            />
                          )}
                        />
                        <Autocomplete disableClearable id="tags-outlined-modules" options={modules} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => `${option.make} ${option.model} ${option.size}`} value={modules.modId} onChange={(event, value) => setModuleId(value.modId)} style={{ width: 225 }}
                          renderInput={(params) => (
                            <TextField className='input'  {...params} variant="filled" size="small" label="Module" margin="dense" width="80%"
                            />
                          )}
                        />
                        <Autocomplete disableClearable id="tags-outlined-inverters" options={inverters} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => `${option.make} ${option.model}`} value={inverters.invId} onChange={(event, value) => setInverterId(value.invId)} style={{ width: 225 }}
                          renderInput={(params) => (
                            <TextField className='input'  {...params} variant="filled" size="small" label="Inverter" margin="dense" width="80%"
                            />
                          )}
                        />
                        <TextField className='input' style={{ width: 225 }} label="PPW" variant="filled" size="small" type='number' margin="dense" onChange={e => setTeamPpw(e.target.value)}></TextField>
                        <TextField className='input' style={{ width: 225 }} label="Cash PPW" variant="filled" size="small" type='number' margin="dense" onChange={e => setCashPpw(e.target.value)}></TextField>
                      </div>
                      <div style={{ alignItems: 'flex-end' }} className='addItem1'>
                        <Autocomplete disableClearable id="tags-outlined-loan-1" options={loanProducts} groupBy={(option) => option.loanName} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => `${option.loanName} ${option.loanTerm}yr ${option.loanInterest}%`} value={loanProducts.loanId} onChange={(event, value) => setLoanId1(value.loanId)} style={{ width: 225 }}
                          renderInput={(params) => (
                            <TextField className='input' {...params} variant="filled" size="small" label="Loan Option 1" margin="dense" fullWidth
                            />
                          )}
                        />
                        <Autocomplete style={{ width: 225 }} multiple disableClearable disableCloseOnSelect limitTags={4} groupBy={(option) => option.loanName} id="tags-outlined" options={loanProducts} getOptionLabel={(option) => `${option.loanName} ${option.loanTerm}yr ${option.loanInterest}%`} value={loanProducts.loanId} onChange={(event, value) => setLoanOption1(value)}
                          renderInput={(params) => (
                            <TextField className='input' {...params} variant="filled" size="small" label="Option 1 Choices" margin="dense" helperText={`Loan 1 Choices in Proposalist`} fullWidth
                            />
                          )}
                        />
                      </div>
                      <div style={{ alignItems: 'flex-end' }} className='addItem1'>
                        <Autocomplete disableClearable id="tags-outlined-loan-4" options={loanProducts} groupBy={(option) => option.loanName} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => `${option.loanName} ${option.loanTerm}yr ${option.loanInterest}%`} value={loanProducts.loanId} onChange={(event, value) => setLoanId2(value.loanId)} style={{ width: 225 }}
                          renderInput={(params) => (
                            <TextField className='input' {...params} variant="filled" size="small" label="Loan Option 2" margin="dense" fullWidth
                            />
                          )}
                        />
                        <Autocomplete style={{ width: 225 }} getOptionDisabled={(options) => (loanOption2.length > 2 ? true : false)} multiple disableClearable disableCloseOnSelect limitTags={4} groupBy={(option) => option.loanName} id="tags-outlined-loan-2-options" options={loanProducts} getOptionLabel={(option) => `${option.loanName} ${option.loanTerm}yr ${option.loanInterest}%`} value={loanProducts.loanId} onChange={(event, value) => setLoanOption2(value)}
                          renderInput={(params) => (
                            <TextField className='input' {...params} variant="filled" size="small" label="Option 2 Choices" margin="dense" helperText={`Loan 2 Choices in Proposalist`} fullWidth
                            />
                          )}
                        />

                      </div>
                    </div>
                    <form >
                      <span>Change PPW when special loan selected? </span>
                      <input className='input' type="radio" name='specialLoanIncrease' onChange={e => setSpecialLoanIncrease('1')} checked={specialLoanIncrease === '1' ? 'checked' : ''} />
                      <span>Yes</span>
                      <input className='input' type="radio" name='specialLoanIncrease' onChange={e => setSpecialLoanIncrease('0')} checked={specialLoanIncrease === '0' ? 'checked' : ''} />
                      <span>No</span>
                    </form>
                    <form >
                      <span>$800 Customer Incentive: </span>
                      <input className='input' type="radio" name='adder' onChange={e => setAdder('1')} checked={adder === '1' ? 'checked' : ''} />
                      <span>Yes</span>
                      <input className='input' type="radio" name='adder' onChange={e => setAdder('0')} checked={adder === '0' ? 'checked' : ''} />
                      <span>No</span>
                    </form>
                    <form >
                      <span>Default Nest: </span>
                      <input className='input' type="radio" name='nest' onChange={e => setNest('1')} checked={nest === '1' ? 'checked' : ''} />
                      <span>Yes</span>
                      <input className='input' type="radio" name='nest' onChange={e => setNest('0')} checked={nest === '0' ? 'checked' : ''} />
                      <span>No</span>
                    </form>
                    <form >
                      <span>PPA Products: </span>
                      <input className='input' type="radio" name='hasPpa' onChange={e => setHasPpa('1')} checked={hasPpa === '1' ? 'checked' : ''} />
                      <span>Yes</span>
                      <input className='input' type="radio" name='hasPpa' onChange={e => setHasPpa('0')} checked={hasPpa === '0' ? 'checked' : ''} />
                      <span>No</span>
                    </form>
                    {/* <form >
                    <span>PPW Override: </span>
                    <span>Yes</span>
                    <input className='input' type="radio" name='ppwOverride' onChange={e => setHasTeamPpw('1')} />
                    <span>No</span>
                    <input className='input' type="radio" name='ppwOverride' onChange={e => setHasTeamPpw('0')} checked={hasTeamPpw === '0' ? 'checked' : ''} />
                  </form> */}


                    <div>
                      <button onClick={() => { setAddSTeam(!addSTeam); addSalesTeam() }}>Create New Sales Team</button>
                    </div>
                    <button onClick={() => setAddSTeam(!addSTeam)}>Cancel</button>
                  </>
                ) : (
                  <>
                    <AuthGroupWrapper requiredGroups={['Super-Admin']} >
                      <div>
                        <button onClick={() => { setAddSTeam(!addSTeam); time() }}>Add New Sales Team</button>
                      </div>
                    </AuthGroupWrapper>
                  </>
                )}
                {massTeamEdit ? (
                  <>
                    <div>
                      <span>Current Option 1 </span>
                      <select onChange={e => setPreLoanId1Team(e.target.value)} className='input'>
                        <option style={{ display: 'none' }} >
                          Current Option 1
                        </option>
                        {mappedLoans}
                      </select>
                      <span>New Option 1 </span>
                      <select onChange={e => setNewLoanId1Team(e.target.value)} className='input'>
                        <option style={{ display: 'none' }} >
                          New Option 1
                        </option>
                        {mappedLoans}
                      </select>
                    </div>
                    <div>
                      <button onClick={() => updateLoan1Team()}>Update Sales Teams with Current Option 1 to New Option 1</button>
                    </div>
                    <div>
                      <span>Current Option 2 </span>
                      <select onChange={e => setPreLoanId2Team(e.target.value)} className='input'>
                        <option style={{ display: 'none' }} >
                          Current Option 2
                        </option>
                        {mappedLoans}
                      </select>
                      <span>New Option 2 </span>
                      <select onChange={e => setNewLoanId2Team(e.target.value)} className='input'>
                        <option style={{ display: 'none' }} >
                          New Option 2
                        </option>
                        {mappedLoans}
                      </select>
                    </div>
                    <div>
                      <button onClick={() => updateLoan2Team()}>Update Sales Teams with Current Option 2 to New Option 2</button>
                    </div>
                    <button onClick={() => setMassTeamEdit(!massTeamEdit)}>Cancel</button>
                  </>
                ) : (
                  <>
                    <AuthGroupWrapper requiredGroups={['Super-Admin']} >
                      <div>
                        <button onClick={() => { setMassTeamEdit(!massTeamEdit); time() }}>Mass Update</button>
                      </div>
                    </AuthGroupWrapper>
                  </>
                )}
                {salesTeams.map(salesTeam => {
                  return <SalesTeams key={salesTeam.team_id} salesTeam={salesTeam} mappedModules={mappedModules} mappedLoans={mappedLoans} mappedInverters={mappedInverters} getSalesTeams={getSalesTeams} loanProducts={loanProducts} modules={modules} inverters={inverters} />
                })}
                <div className='filler'></div>

              </>
            ) : (
              <>
              </>
            )}
            {viewUsers ? <Users /> : ''}
            {viewLoanProducts ? (
              <>
                {addLoan ? (
                  <>
                    <div>
                      <span>Financing Product</span>
                    </div>
                    <form >
                      <span>Is a PPA Product? </span>
                      <input className='input' type="radio" name='isPpa' onChange={e => setIsPpa('1')} checked={isPpa === '1' ? 'checked' : ''} />
                      <span>Yes</span>
                      <input className='input' type="radio" name='isPpa' onChange={e => setIsPpa('0')} checked={isPpa === '0' ? 'checked' : ''} />
                      <span>No</span>
                    </form>
                    {+isPpa === 1 ? (
                      <>
                        <div className='addItem'>
                          <div className='addItem1'>
                            <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Financial Partner' onChange={e => setLoanName(e.target.value)}></TextField>
                            <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Term Length' onChange={e => setLoanTerm(e.target.value)}></TextField>
                            <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='PPA Rate' onChange={e => setPpaRate(e.target.value)}></TextField>
                            <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='PPA Escalator' onChange={e => setPpaEscalator(e.target.value)}></TextField>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className='addItem'>
                          <div className='addItem1'>
                            <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Financial Partner' onChange={e => setLoanName(e.target.value)}></TextField>
                            <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Term Length' onChange={e => setLoanTerm(e.target.value)}></TextField>
                            <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Interest Rate' onChange={e => setLoanInterest(e.target.value)}></TextField>
                            <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='pmt ITC Applied' onChange={e => setPrePmtFactor(e.target.value)}></TextField>
                            <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Dealer Fee' onChange={e => setDealerFee(e.target.value)}></TextField>
                          </div>
                          <div className='addItem1'>
                            <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='pmt ITC NOT Applied' onChange={e => setNoItcPmtFactor(e.target.value)}></TextField>
                            <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='interest only' onChange={e => setIntOnlyPmtFactor(e.target.value)}></TextField>
                            <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='ITC' onChange={e => setItc(e.target.value / 100)}></TextField>
                            <TextField className='input' style={{ width: 225 }} type='number' variant="filled" size="small" margin="dense" label='Optional Special PPW' helperText={`Increase PPW to this price when loan is selected`} onChange={e => setSpecialPrice(e.target.value)}></TextField>
                          </div>
                        </div>
                      </>)}
                    <div>
                      <button onClick={() => { setAddLoan(!addLoan); addLoanProduct() }} >Create New Loan Product</button>
                    </div>
                    <div>
                      <button onClick={() => setAddLoan(!addLoan)} >Cancel</button>
                    </div>
                  </>
                ) : (
                  <>
                    <AuthGroupWrapper requiredGroups={['Super-Admin']} >
                      <button onClick={() => setAddLoan(!addLoan)} >Add New Loan Product</button>
                    </AuthGroupWrapper>
                  </>
                )}
                {loanProducts.map(loan => {
                  return <LoanProducts key={loan.loanId} loan={loan} getLoanProducts={getLoanProducts}
                  />
                })}
                <div className='filler'></div>
              </>
            ) : (
              <>
                <div className='filler'></div>
                <div className='filler'></div>
                <div className='filler'></div>
                <div className='filler'></div>
                <div className='filler'></div>
                <div className='filler'></div>
                <div className='filler'></div>
                <div className='filler'></div>
                <div className='filler'></div>
                <div className='filler'></div>
                <div className='filler'></div>
                <div className='filler'></div>
                <div className='filler'></div>
                <div className='filler'></div>
              </>
            )
            }

          </div>
        </div>
      </div>
    </AuthGroupWrapper>
  )
}
export default Admin
